import React from "react";

import "./CubeQueryWizardButton.scss";

export class CubeQueryWizardButton extends React.Component {
  render() {
    const { onClick } = this.props;
    const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";
    return !IS_BIRD_APP ? (
      <div className="QueryWizardButton__container">
        <button className="QueryWizardButton btn btn-primary" onClick={onClick}>
          Query Wizard
        </button>
      </div>
    ) : null;
  }
}
